<template>
    <b-container 
        class="content" 
        fluid 
        v-loading="isLoaded" 
        :element-loading-text="$t('sourceLoading')"
    >

            <b-row style="border-bottom:1px solid #ddd;margin-bottom:2em;">
                    <h3>{{ this.$t('tagManagement') }}</h3>
            </b-row>
            <b-row style="justify-content:space-between;">
                <b-col cols="8">
                    <ul class="nav nav-tabs">
                        <li v-for="(tab,tabKey) in tabs" class="nav-item p-2" style="cursor: pointer;" :style="tab.isActive ? tab.style.border : ''" :key="tabKey">
                            <div @click="activate(tabKey)" :class="{'nav-link': true, 'active': tab.isActive}" :style="tab.isActive ? tab.style.tab : ''">{{ tab.name }}  <b-badge pill :style="tab.isActive ? tab.style.badge : ''">{{ tab.data.length }}</b-badge></div>
                        </li>
                    </ul>
                </b-col>
                <b-col cols="4" style="float:right;text-align:right;">
                    <template v-if="tabs.units.isActive">
                        <b-button key="addUnitBtn" style="background-color:#41B884;" @click="openInsertItemModal('unit')" lg="2" class="pb-2">{{ $t('addUnitBtn') }}</b-button>
                    </template>
                    <template v-else-if="tabs.sourceType.isActive">
                        <b-button key="addSourceTypeBtn" style="background-color:#41B884;" @click="openInsertItemModal('source-type')" lg="2" class="pb-2">{{ $t('addSourceTypeBtn') }}</b-button>
                    </template>
                    <template v-else-if="tabs.sourceTypeGroup.isActive">
                        <b-button key="addSourceTypeGroupBtn" style="background-color:#41B884;" @click="openInsertItemModal('source-type-group')" lg="2" class="pb-2">{{ $t('addSourceTypeGroupBtn') }}</b-button>
                    </template>
                    <template v-else-if="tabs.scopeGroup.isActive">
                        <b-button key="addScopeBtn" style="background-color:#41B884;" @click="openInsertItemModal('scope-group')" lg="2" class="pb-2">{{ $t('addScopeBtn') }}</b-button>
                    </template>
                    <template v-else>
                    </template>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mt-3" md="2">
                    <b-form-input
                    v-model="searchInput"
                    style="padding: 5px 10px;"
                    :placeholder="$t('searchUnit')"
                    @input="filterData"/>
                </b-col>
            </b-row>
            <b-modal ref="itemEditModal" id="itemEditModal" size="lg" @show="onShowModal" @hide="onHideModal" top :title="`${$t(activeTab)} - ${$t(modalType)}`"> 
                <div class="d-block text-center">
                    <template v-if="showModal">
                        <template v-for="(field, index) in tabs[activeTab].fields">
                            <b-row v-if="field.type == 'text'" class="mt-2" :key="`${activeTab}-${index}`">
                                <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                                    <!-- {{ $t(field.header) }} -->
                                    {{ $t(field.label) }}
                                </b-col>
                                <b-col>
                                    <!-- <b-form-input v-model="editedItem.cols[field.key].editedValue" placeholder="name"/> -->
                                    <b-form-input v-model="editedItem.cols[field.key.split('.')[1]].editedValue" placeholder="name"/>
                                </b-col>
                            </b-row>
                            <b-row v-else-if="field.type == 'long-text'" class="mt-2" :key="`${activeTab}-${index}`">
                                <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                                    <!-- {{ $t(field.header) }} -->
                                    {{ $t(field.label) }}
                                </b-col>
                                <b-col>
                                    <!-- <b-form-textarea v-model="editedItem.cols[field.key].editedValue" placeholder="..."/> -->
                                    <b-form-textarea v-model="editedItem.cols[field.key.split('.')[1]].editedValue" placeholder="..."/>
                                </b-col>
                            </b-row>
                        </template>
                        <template v-if="activeTab == 'units'">
                            <b-row class="mt-2" :key="`${activeTab}-unit-type`">
                                <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                                    {{ $t('type') }}
                                </b-col>
                                <b-col md="9" style="justify-content:left;">
                                    <b-form-select v-model="editedItem.cols.type.editedValue" @change="forceUpdate" id="unitTypeSelect" ref="unitTypeSelect" class="white-select" size="m">
                                        <b-form-select-option v-for="unit in unitTypes" :key="unit" :value="unit"> {{ $t(unit) }} </b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </template>
                        <template v-else-if="activeTab == 'sourceType'">
                            <b-row class="mt-2" :key="`${activeTab}-unit`">
                                <b-col>
                                    <b-row class="mt-2">
                                        <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                                            {{ $t("units") }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="mt-2">
                                            <el-transfer
                                                style="text-align: left;"
                                                v-model="editedItem.units.editedValue"
                                                :titles="[$t('allUnits'), $t('selectedUnits')]"
                                                filterable
                                                :props="{
                                                    key: 'id',
                                                    label: 'label'
                                                }"
                                                :format="{
                                                    noChecked: '${total}',
                                                    hasChecked: '${checked}/${total}'
                                                }"
                                                :data="unitList"
                                                :filter-placeholder="$t('searchUnit')"
                                                @left-check-change="isChanged = true"
                                                @right-check-change="isChanged = true"
                                                @change="updateTypeGroupUnitFactorOptions"
                                                key="modal-transfer-unit"
                                            >
                                            </el-transfer>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row v-for="item,key in editedItem.cols['source_factors'].editedValue" class="mt-2" :key="`${activeTab}-factor-${key}`">
                                <b-col>
                                    <b-row class="mt-2">
                                        <b-col class="mt-2" style="text-align: left;font-weight: bold;" md="1">{{ $t(key) }}</b-col>
                                        <b-col class="mt-2" style="font-weight: bold;" md="2">{{ $t("base") }}</b-col>
                                        <b-col class="mt-2" style="font-weight: bold;" md="2">{{ $t("target") }}</b-col>
                                        <b-col class="mt-2" style="font-weight: bold;" md="4">{{ $t("anchor") }}</b-col>
                                        <b-col class="mt-2" style="font-weight: bold;" md="3">{{ $t("example") }}</b-col>
                                    </b-row>
                                    <b-row v-for="inputFields,key2 in item" :key="`${activeTab}-factor-${key}-${key2}`">
                                        <b-col class="mt-2" style="text-align: left;" md="1">
                                            {{ $t(key2) }}:
                                        </b-col>
                                        <b-col class="mt-2" md="2">
                                            <b-form-select v-model="inputFields.from" @change="forceUpdate" :key="`from-${key}`" class="white-select" size="m">
                                                <b-form-select-option v-for="unit, i in unitFilter[key]" :key="`from-unit-${i}`" :value="unit.id"> {{ unit.name }} </b-form-select-option>
                                            </b-form-select>
                                        </b-col>
                                        <b-col class="mt-2" md="2">
                                            <b-form-select v-model="inputFields.to" @change="forceUpdate" :key="`from-${key2}`" class="white-select" size="m">
                                                <b-form-select-option v-for="unit, i in unitFilter[key2]" :key="`to-unit-${i}`" :value="unit.id"> {{ unit.name }} </b-form-select-option>
                                            </b-form-select>
                                        </b-col>
                                        <b-col class="mt-2" md="4">
                                            <b-form-input type="number" v-model="inputFields.value" @input="forceUpdate"/>
                                        </b-col>
                                        <b-col class="mt-2" md="3">
                                            {{ getExampleConversion(inputFields.from,inputFields.to,inputFields.value) }}
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <hr>
                            </b-row>
                        </template>
                        <template v-if="activeTab == 'scopeGroup'">
                            <b-row class="mt-2" :key="`${activeTab}-top`">
                                <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                                    {{ $t('top') }}
                                </b-col>
                                <b-col md="9" style="justify-content:left;">
                                    <b-form-select v-model="editedItem.top.editedValue" @change="forceUpdate" id="topSelect" ref="topSelect" class="white-select" size="m">
                                        <b-form-select-option v-for="(top,index) in tops" :key="index" :value="top.id"> {{ top.name }} </b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2" :key="`${activeTab}-scope`">
                                <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                                    {{ $t('scope') }}
                                </b-col>
                                <b-col md="9" style="justify-content:left;">
                                    <b-form-select v-model="editedItem.scope.editedValue" @change="forceUpdate" id="scopeSelect" ref="scopeSelect" class="white-select" size="m">
                                        <b-form-select-option v-for="(scope,index) in scopes" :key="index" :value="scope.id"> {{ scope.name }} </b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2" :key="`${activeTab}-source-type-group-header`">
                                <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                                    {{ $t('sourceTypeGroupHeader') }}
                                </b-col>
                                <b-col>
                                    <b-form-input v-model="editedItem.cols['sourceTypeGroupsHeader'].editedValue" placeholder="Usage For"/>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2" :key="`${activeTab}-scope-group-icon`">
                                <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                                    {{ $t('scopeIcon') }}
                                </b-col>
                                <b-col md="8">
                                    <b-form-input v-model.lazy="editedItem.cols['icon'].editedValue" @input="forceUpdate" placeholder="Icon Code"/>
                                </b-col>
                                <b-col align-self="center" md="1" :key="`icon-col-${editedItem.cols.icon.editedValue}`">
                                    <i v-bind:class="getIconCode()" :key="`icon--${editedItem.cols.icon.editedValue}`"></i>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2" :key="`${activeTab}-hazardous`">
                                <b-col style="text-align: left;font-weight: bold; margin-top:7px;">
                                    <b-form-checkbox
                                        v-model="editedItem.hazardous.editedValue"
                                        name="checkbox-1"
                                        :value="true"
                                        :unchecked-value="false"
                                        @change="forceUpdate"
                                    >
                                        <span style="color:#ff0000;">
                                            {{ $t('couldBeHazardous') }} 
                                        </span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-row class="mt-2">
                                        <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                                            {{ $t("SourceTypeGroups") }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="mt-2">
                                            <el-transfer
                                                style="text-align: left;"
                                                v-model="editedItem.sourceTypeGroups.editedValue"
                                                :titles="[$t('allSourceTypeGroups'), $t('selectedSourceTypeGroups')]"
                                                filterable
                                                :props="{
                                                    key: 'id',
                                                    label: 'label'
                                                }"
                                                :format="{
                                                    noChecked: '${total}',
                                                    hasChecked: '${checked}/${total}'
                                                }"
                                                :data="sourceTypeGroupList"
                                                :filter-placeholder="$t('searchSourceTypeGroup')"
                                                @left-check-change="isChanged = true"
                                                @right-check-change="isChanged = true"
                                                @change="checkSourceTypeGroups"
                                                key="modal-transfer-sourceTypeGroups"
                                            >
                                            </el-transfer>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-row class="mt-2" style="justify-content:space-between;">
                                        <b-col style="text-align: left;font-weight: bold; margin-top:7px;" md="3">
                                            {{ $t("SourceTypes") }}
                                        </b-col>
                                        <b-col style="float:right;font-weight: bold; margin-top:7px;margin-right:7px;" md="5">
                                            <b-form-select v-model="editedItem.selectedSourceTypeGroup" @change="forceUpdate" id="SourceTypeGroupSelect" ref="SourceTypeGroupSelect" class="white-select" size="m" style="width:270px;">
                                                <b-form-select-option v-for="sourceTypeGroupId in editedItem.sourceTypeGroups.editedValue" :key="sourceTypeGroupId" :value="sourceTypeGroupId"> {{ sourceTypeGroupMap[sourceTypeGroupId] }} </b-form-select-option>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row v-show="showModalSourceTypeSelect()">
                                        <b-col class="mt-2">
                                            <el-transfer
                                                style="text-align: left;"
                                                v-model="editedItem.sourceTypes.editedValue[editedItem.selectedSourceTypeGroup]"
                                                :titles="[$t('allSourceTypes'), $t('selectedSourceTypes')]"
                                                filterable
                                                :props="{
                                                    key: 'id',
                                                    label: 'label'
                                                }"
                                                :format="{
                                                    noChecked: '${total}',
                                                    hasChecked: '${checked}/${total}'
                                                }"
                                                :data="sourceTypeList"
                                                :filter-placeholder="$t('searchSourceType')"
                                                @left-check-change="isChanged = true"
                                                @right-check-change="isChanged = true"
                                                @change="forceUpdate"
                                                key="modal-transfer-sourceTypes"
                                            >
                                            </el-transfer>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </template>
                    </template>
                </div>

                <div slot="modal-footer">
                    <template v-if="inProgress">
                        <div style="color:#ff0000;">
                            {{ $t('longProcessNotification') }}
                        </div>
                    </template>
                    <template v-else-if="removingProcess">
                        <div style="display:inline-block;width:100%;">
                            <span style="color:#ff0000;align:left;"> {{ $t('deletion-warn') }} </span>
                            <b-button v-b-modal.warn v-b-tooltip.hover @click="deleteItem()" :disabled="inProgress" variant="danger">{{ $t('yes') }}</b-button>
                            <b-button v-b-tooltip.hover @click="removingProcess = !removingProcess" :disabled="inProgress" variant="secondary">{{ $t('no') }}</b-button>
                        </div>
                    </template>
                    <template v-else-if="modalType === 'update' && editedItem != null">
                        <b-button v-b-tooltip.hover @click="updateItem()" :disabled="inProgress" variant="primary">{{ $t('save') }}</b-button>
                        <b-button v-b-tooltip.hover @click="cancelItem()" :disabled="inProgress" variant="secondary">{{ $t('cancel') }}</b-button>
                        <b-button v-b-modal.warn v-b-tooltip.hover @click="removingProcess = !removingProcess" :disabled="inProgress" variant="danger">{{ $t('delete') }}</b-button>
                    </template>
                    <template v-else>
                        <b-button v-b-tooltip.hover @click="insertItem()" :disabled="inProgress" variant="primary">{{ $t('save') }}</b-button>
                        <b-button v-b-tooltip.hover @click="cancelItem()" :disabled="inProgress" variant="danger">{{ $t('cancel') }}</b-button>
                    </template>
                </div>
            </b-modal>
            
            <template>
                
                <!-- <table class="table table-hover" style="table-layout: fixed;">
                    <thead>
                        <tr>
                            <th 
                                v-for="(field,index) in tabs[activeTab].fields" 
                                style="text-align:left;font-size: 1em"
                                :style="{width: field.key == 'icon' ? '4em' : '10em'}"
                                :key="`${activeTab}-${index}`"
                                >{{ $t(field.header) }}</th> 
                            <th id="editColumn" style="width: 4em;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index)  in itemsForList(tabs[activeTab].data)" :key="`${activeTab}-${index}`">
                            <td 
                                v-for="(field, indexx) in tabs[activeTab].fields" 
                                :key="indexx" style="text-align:left;font-size: 0.875em;">
                                
                                <template v-if="field.type == 'list'">
                                    <span> 
                                        {{ shortenList(item.cols[field.key].value ,3) }} 
                                    </span>
                                </template>
                                <template v-else-if="field.type == 'text' || field.type == 'number'">
                                    <span>
                                        {{ item.cols[field.key].value }}
                                    </span>
                                </template>
                                <template v-else-if="field.type == 'icon'">
                                    <span :key="`icon-${activeTab}-col-${index}-${item.cols[field.key].value}`">
                                        <i v-bind:class="`${item.cols[field.key].value} fa-2x`" :key="`icon-${activeTab}-${index}-${item.cols[field.key].value}`"></i>
                                    </span>
                                </template>
                                <template v-else-if="field.type == 'select'">
                                    <span>
                                        {{ $t(item.cols[field.key].value) }}
                                    </span>
                                </template>

                                <template v-else-if="field.type == 'long-text'">
                                    <span>
                                        {{ item.cols[field.key].value | shortenText(20) }}
                                    </span>
                                </template>

                                <template v-else-if="field.type == 'boolean'">
                                    <span v-if="item.cols[field.key].value" :key="`${item.id}-${field.key}-true`">
                                        <i style="color: #41B884" class="fas fa-check fa-lg"></i>
                                    </span>
                                    <span v-else :key="`${item.id}-${field.key}-false`">
                                        <i style="color: #ff0000" class="fas fa-times fa-lg"></i>
                                    </span>
                                </template>

                                <template v-else-if="field.type == 'relation'">
                                    <span>
                                        {{ item.cols[field.key].value.name }}
                                    </span>
                                </template>
                                <template v-else>
                                    <span>
                                        {{ item.cols[field.key].value }}
                                    </span>
                                </template>
                            </td>
                            <td style="width:50px; margin-right: 4px;" class="edit-column">
                                <div class="tableBodyCell">
                                    <div
                                        @click="openEditModal(item)"
                                        key="editspan"
                                        style="color: #8888; cursor: pointer"
                                        >
                                        <i class="fas fa-edit fa-lg"></i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table> -->
                <b-table
                    :items="itemsForList(tabs[activeTab].data)"
                    :fields="tabs[activeTab].fields"
                    :per-page="perPage"
                    :current-page="currentPage"
                    id="itemList"
                    responsive
                >
                    <template #cell(cols.icon.value)="data">
                        <div v-html="data.value"></div>
                    </template>
                    <template #cell(cols.hazardous.value)="data">
                        <div v-html="data.value"></div>
                    </template>
                    <template #cell(edit)="data">
                        <div
                            @click="openEditModal(data.item)"
                            key="editspan"
                            style="color: #8888; cursor: pointer"
                        >
                            <i class="fas fa-edit fa-lg"></i>
                        </div>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="itemList"
                    align="right"
                ></b-pagination>
            </template>
    </b-container>
</template>

<script>
import VueTable from '../../components/Table';
import _ from 'lodash';
//import moment from 'moment';

export default {
    components: {VueTable},
    name: 'Tags',
    data() {
        return {
            tabs:{
                units:{
                    isActive:true,
                    data:[],
                    fields: [
                        // {"key":"name","header":"code","type":"text"},
                        // {"key":"description","header":"description","type":"long-text"},
                        // {"key":"type","header":"type","type":"select"}
                        {
                            key: 'cols.name.value',
                            label: this.$t(this.$t('code')),
                            type: "text",
                        },
                        {
                            key: 'cols.description.value',
                            label: this.$t('description'),
                            class: 'truncate',
                            type: 'long-text'
                        },
                        {
                            key: 'cols.type.value',
                            label: this.$t('type'),
                            type: 'select'
                        },
                        {
                            key: 'edit',
                            label: this.$t('edit'),
                        },
                    ],
                    name: this.$t('units'),
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    },
                    actions:{
                        insert: '/unit',
                        update: '/unit',
                        delete: '/unit'
                    },
                    type: 'unit'
                },
                sourceType:{
                    isActive:false,
                    data:[],
                    fields: [
                        // {"key":"name","header":"code","type":"text"},
                        // {"key":"display_name","header":"displayName","type":"text"},
                        // {"key":"description","header":"description","type":"long-text"},
                        // {"key":"units","header":"units","type":"list"}
                        {
                            key: 'cols.name.value',
                            label: this.$t('code'),
                            type: 'text'
                        },
                        {
                            key: 'cols.display_name.value',
                            label: this.$t('displayName'),
                            type: 'text'
                        },
                        {
                            key: 'cols.description.value',
                            label: this.$t('description'),
                            class: 'truncate',
                            type: 'long-text'
                        },
                        {
                            key: 'cols.units.value',
                            label: this.$t('units'),
                            formatter: (unit) => this.shortenList(unit, 3),
                            type: 'list'
                        },
                        {
                            key: 'edit',
                            label: this.$t('edit'),
                        },
                    ],
                    name: this.$t('sourceType'),
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    },
                    actions:{
                        insert: '/sourceType',
                        update: '/sourceType',
                        delete: '/tag'
                    },
                    type: 'source-type'
                },
                sourceTypeGroup:{
                    isActive:false,
                    data:[],
                    fields: [
                        // {"key":"name","header":"code","type":"text"},
                        // {"key":"display_name","header":"displayName","type":"text"},
                        // {"key":"description","header":"description","type":"long-text"}
                        {
                            key: 'cols.name.value',
                            label: this.$t('code'),
                            type: 'text'
                        },
                        {
                            key: 'cols.display_name.value',
                            label: this.$t('displayName'),
                            type: 'text'
                        },
                        {
                            key: 'cols.description.value',
                            label: this.$t('description'),
                            class: 'truncate',
                            type: 'long-text'
                        },
                        {
                            key: 'edit',
                            label: this.$t('edit'),
                        },
                    ],
                    name: this.$t('sourceTypeGroup'),
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    },
                    actions:{
                        insert: '/tag',
                        update: '/tag',
                        delete: '/tag'
                    },
                    type: 'source-type-group'
                },
                scopeGroup:{
                    isActive:false,
                    data:[],
                    fields: [
                        // {"key":"icon","header":"Icon","type":"icon"},
                        // {"key":"name","header":"code","type":"text"},
                        // {"key":"display_name","header":"displayName","type":"text"},
                        // {"key":"description","header":"description","type":"long-text"},
                        // {"key":"scope","header":"scope","type":"relation"},
                        // {"key":"top","header":"top","type":"relation"},
                        // {"key":"sourceTypeGroups","header":"sourceTypeGroups","type":"list"},
                        // {"key":"sourceTypes","header":"sourceTypes","type":"list"},
                        // {"key":"hazardous","header":"hazardous","type":"boolean"}
                        {
                            key: 'cols.icon.value',
                            label: this.$t('Icon'),
                            formatter: (icon) => `<i class="${icon} fa-2x"></i>`,
                            type: 'icon'
                        },
                        {
                            key: 'cols.name.value',
                            label: this.$t('code'),
                            type: 'text'
                        },
                        {
                            key: 'cols.display_name.value',
                            label: this.$t('displayName'),
                            type: 'text'
                        },
                        {
                            key: 'cols.description.value',
                            label: this.$t('description'),
                            class: 'truncate',
                            type: 'long-text'
                        },
                        {
                            key: 'cols.scope.value',
                            label: this.$t('scope'),
                            formatter: (scope) => _.get(scope, 'name') || '-',
                            type: 'relation'
                        },
                        {
                            key: 'cols.top.value',
                            label: this.$t('top'),
                            formatter: (top) => _.get(top, 'name') || '-',
                            type: 'relation'
                        },
                        {
                            key: 'cols.sourceTypeGroups.value',
                            label: this.$t('sourceTypeGroups'),
                            formatter: (sourceTypeGroup) => this.shortenList(sourceTypeGroup, 3),
                            type: 'list'
                        },
                        {
                            key: 'cols.sourceTypes.value',
                            label: this.$t('sourceTypes'),
                            formatter: (sourceType) => this.shortenList(sourceType, 3),
                            type: 'list'
                        },
                        {
                            key: 'cols.hazardous.value',
                            label: this.$t('hazardous'),
                            formatter: (isHazardous) => `<i class="fas fa-lg ${isHazardous ? 'fa-check text-success' : 'fa-times text-danger'}"></i>`,
                            type: 'boolean'
                        },
                        {
                            key: 'edit',
                            label: this.$t('edit'),
                        },
                    ],
                    name: this.$t('scopeGroup'),
                    style:{
                        border:{'border-bottom':'3px solid #022B49'},
                        tab:{'color':'#022B49'},
                        badge:{'background-color':'#022B49'}
                    },
                    actions:{
                        insert: '/scopeGroup',
                        update: '/scopeGroup',
                        delete: '/tag'
                    },
                    type: 'scope-group'
                }
            },
            error:{},
            activeTab:'units',
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            isLoaded: false,
            scopes: [],
            tops: [],
            modalType: null,
            editedItem: null,
            removingProcess: false,
            inProgress: false,
            searchInput: '',
            showModal: false,
            sourceTypeList: [],
            sourceTypeGroupList: [],
            sourceTypeMap: {},
            sourceTypeGroupMap: {},
            isChanged: false,
            hazardous: {},
            unitList: [],
            unitMap: {},
            unitTypes:[
                'mass',
                'volume',
                'energy',
                'other'
            ],
            unitFilter: {
                'mass':[],
                'volume':[],
                'energy':[],
                'other':[]
            },
            unitTypeMap:{id:{},name:{}}
        };
    },
    methods: {
        getIconCode(){
            return this.editedItem.cols['icon'].editedValue + ' fa-2x';
        },
        getExampleConversion(from,to,value){
            if(from && to && value != null){
                let val = 1*_.toNumber(value);
                return `1 ${this.unitMap[from]} = ${val} ${this.unitMap[to]}`;
            }
        },
        forceUpdate() {
            this.isChanged = true;
            this.$forceUpdate();
        },
        activate(key){
            this.activeTab = key;
            _.each(this.tabs, (tab,tabKey)=> {
                this.currentPage = 1;
                tab.isActive = key==tabKey;
            });
        },
        filterData(){
            this.currentPage = 1;
            this.forceUpdate();
        },
        itemsForList(data){
            let searchedDataItems = this.searchData(data);
            this.totalRows = searchedDataItems.length;
            return searchedDataItems;
            // return searchedDataItems.slice(
            //             (this.currentPage - 1) * this.perPage,
            //             this.currentPage * this.perPage,
            //         );
        },
        searchData(dataItems){
            if (this.searchInput.length < 1) {
                return dataItems
            } else {
                switch(this.activeTab) {
                    case 'units':
                        return _.filter(dataItems, o => {
                            return (
                                _.includes(_.toLower(o.cols.name.value), _.toLower(this.searchInput))
                                || _.includes(_.toLower(this.$t(o.cols.description.value)), _.toLower(this.searchInput))
                                || _.includes(_.toLower(this.$t(o.cols.type.value)), _.toLower(this.searchInput))
                            )
                        });
                    case 'sourceType':
                        return _.filter(dataItems, o => {
                            return (
                                _.includes(_.toLower(o.cols.name.value), _.toLower(this.searchInput))
                                || _.includes(_.toLower(this.$t(o.cols.display_name.value)), _.toLower(this.searchInput))
                                || _.includes(_.toLower(this.$t(o.cols.description.value)), _.toLower(this.searchInput))
                                || _.includes(_.toLower(_.join(_.map(o.cols.units.value, 'label'), ' ')), _.toLower(this.searchInput))
                            )
                        });
                    case 'sourceTypeGroup':
                        return _.filter(dataItems, o => {
                            return (
                                _.includes(_.toLower(o.cols.name.value), _.toLower(this.searchInput))
                                || _.includes(_.toLower(this.$t(o.cols.display_name.value)), _.toLower(this.searchInput))
                                || _.includes(_.toLower(this.$t(o.cols.description.value)), _.toLower(this.searchInput))
                            )
                        });
                    case 'scopeGroup':
                        return _.filter(dataItems, o => {
                            return (
                                _.includes(_.toLower(o.cols.name.value), _.toLower(this.searchInput))
                                || _.includes(_.toLower(this.$t(o.cols.display_name.value)), _.toLower(this.searchInput))
                                || _.includes(_.toLower(this.$t(o.cols.description.value)), _.toLower(this.searchInput))
                                || _.includes(_.toLower(o.cols.scope.value.name), _.toLower(this.searchInput))
                                || _.includes(_.toLower(o.cols.top.value.name), _.toLower(this.searchInput))
                                || _.includes(_.toLower(_.join(_.map(o.cols.sourceTypeGroups.value, 'label'), ' ')), _.toLower(this.searchInput))
                            )
                        });
                    default:
                        return dataItems;
                }
            }
        },
        shortenList(dataList, maxLength){
            if(dataList == undefined || _.isEmpty(dataList)){
                return "-";
            }
            let nameList = _.map(dataList, 'label');
            if(dataList.length > maxLength){
                return _.join(nameList.slice(0,maxLength), ", ")+" "+this.$t('and')+" "+_.toString(nameList.length-maxLength)+" "+this.$t('more');
            }else{
                return _.join(nameList, ", ");
            }
        },
        updateTypeGroupUnitFactorOptions(selectedData){
            let selectedTypes = [];
            _.each(selectedData, o=>{
                if(!_.includes(selectedTypes, this.unitTypeMap.id[o]) && this.unitTypeMap.id[o] != 'other'){
                    selectedTypes.push(this.unitTypeMap.id[o])
                }
            })
            this.editedItem.cols['source_factors'].editedValue = _.pick(this.editedItem.cols['source_factors'].editedValue, selectedTypes)
            _.each(selectedTypes, selectedType=>{
                if(!_.includes(Object.keys(this.editedItem.cols['source_factors'].editedValue), selectedType)){
                    this.editedItem.cols['source_factors'].editedValue[selectedType] = {};
                    _.each(this.unitTypes, unitType=>{
                        if(!(unitType==selectedType || unitType=='other')){
                            this.editedItem.cols['source_factors'].editedValue[selectedType][unitType] = {
                                from:null,
                                to:null,
                                value:null
                            }
                        }
                    })
                }
            });
            this.forceUpdate()
        },
        checkSourceTypeGroups(selectedData,action){
            if(_.isEmpty(this.editedItem.sourceTypeGroups.editedValue)){
                this.editedItem.selectedSourceTypeGroup = null;
            }
            else if(!_.includes(this.editedItem.sourceTypeGroups.editedValue, this.editedItem.selectedSourceTypeGroup)){
                this.editedItem.selectedSourceTypeGroup = _.head(this.editedItem.sourceTypeGroups.editedValue);
            }

            if(action=='left'){
                let newSourceTypes = {};
                _.each(this.editedItem.sourceTypes.editedValue,  (val,key)=>{
                    if(_.includes(selectedData, _.toNumber(key))){
                        newSourceTypes[key]=val;
                    }
                });
                this.editedItem.sourceTypes.editedValue = newSourceTypes;
            }

            this.forceUpdate()
        },
        showModalSourceTypeSelect(){
            return this.editedItem.selectedSourceTypeGroup != null;
        },
        generateNewItem(getId = false){
            let item = {
                name: this.editedItem.cols.name.editedValue,
                description: this.editedItem.cols.description.editedValue
            }
            if(this.modalType == 'update'){
                item['id'] = getId ? this.editedItem.id : null;
            }
            if(this.activeTab != 'units'){
                item['display_name'] = this.editedItem.cols.display_name.editedValue;
                item['type'] = this.editedItem.type;
            }
            else{
                item['type'] = this.editedItem.cols.type.editedValue
            }
            if(this.activeTab == 'sourceType'){
                item['original_units'] = this.editedItem.units.value;
                item['units'] = this.editedItem.units.editedValue;
                item['source_factors'] = [];
                _.each(this.editedItem.cols['source_factors'].editedValue, unitType=>{
                    _.each(unitType, unitValue=>{
                        if(unitValue.from && unitValue.to && unitValue.value != null){
                            item['source_factors'].push({
                                'current_unit_id':unitValue.from, 
                                'target_unit_id':unitValue.to, 
                                'value':_.toNumber(unitValue.value)
                            });
                        }
                    });
                });
            }
            else if(this.activeTab == 'scopeGroup'){
                item['scope'] = this.editedItem.scope.editedValue;
                item['top'] = this.editedItem.top.editedValue;

                item['sourceTypeGroups'] = this.editedItem.sourceTypeGroups.editedValue;
                item['sourceTypes'] = this.editedItem.sourceTypes.editedValue;
                item['hazardous'] = this.editedItem.hazardous.editedValue;

                item['original_sourceTypeGroups'] = this.editedItem.sourceTypeGroups.value;
                item['original_sourceTypes'] = this.editedItem.sourceTypes.value;
                item['original_hazardous'] = this.editedItem.hazardous.value;

                item['hazardous_id'] = _.get(this.hazardous, 'id');

                item['sourceTypeGroupsHeader'] = this.editedItem.cols.sourceTypeGroupsHeader.editedValue;
                item['icon'] = this.editedItem.cols.icon.editedValue;
            }
            return item;
        },
        deleteItem(){
            this.inProgress=true;
            let id = this.editedItem.id;
            return this.axios.delete(`${this.tabs[this.activeTab].actions.delete}/${id}`)
                .then(({data})=>{
                    if(data.result){
                        this.$refs.itemEditModal.hide();
                        this.init();
                    }else{
                        this.removingProcess = false;
                        this.inProgress=false;
                        return this.$message({
                            type: 'error',
                            message: this.$t('targetInUse')
                        });
                    }
                });
        },
        insertItem(){
            this.inProgress=true;
            let newItem = this.generateNewItem(false)
            return this.axios.post(this.tabs[this.activeTab].actions.insert, newItem)
                .then(()=>{
                    this.$refs.itemEditModal.hide();
                    this.init();
                });
        },
        updateItem(){
            this.inProgress=true;
            let newItem = this.generateNewItem(true)
            return this.axios.put(this.tabs[this.activeTab].actions.update, newItem)
                .then(()=>{
                    this.$refs.itemEditModal.hide();
                    this.init();
                });
        },
        cancelItem(){
            this.$refs.itemEditModal.hide()
        },
        openInsertItemModal(key){

            this.modalType = 'insert'

            this.editedItem = {cols:{}};
            this.editedItem.cols['name'] = {value:'',editedValue:''};
            this.editedItem.cols['description'] = {value:'',editedValue:''};

            if(key != 'unit'){
                this.editedItem.cols['display_name'] = {value:'',editedValue:''};
                this.editedItem['type'] = key;
            }
            else{
                this.editedItem.cols['type'] = {value:'other',editedValue:'other'};
            }

            if(key == 'source-type'){
                this.editedItem['units'] = {value:[],editedValue:[]};
                this.editedItem.cols['source_factors'] = {value:{},editedValue:{}}
            }
            else if(key == 'scope-group'){
                this.editedItem['scope'] = {value:{},editedValue:{}};
                this.editedItem['top'] = {value:{},editedValue:{}};
                this.editedItem['sourceTypeGroups'] = {value:[],editedValue:[]};
                this.editedItem['sourceTypes'] = {value:{},editedValue:{}};
                this.editedItem['hazardous'] = {value:false,editedValue:false};
                this.editedItem.cols['sourceTypeGroupsHeader'] = {value:"Usage For",editedValue:"Usage For"};
                this.editedItem.cols['icon'] = {value:"far fa-question-circle",editedValue:"far fa-question-circle"};
            }
            this.$refs.itemEditModal.show()
        },
        openEditModal(item){
            this.modalType = 'update'
            this.editedItem = _.cloneDeep(item);
            this.editedItem['type'] = this.tabs[this.activeTab].type;
            this.$refs.itemEditModal.show()
        },
        onShowModal(){
            this.showModal = true;
        },
        onHideModal(){
            if(this.modalType == 'insert'){
                this.editedItem = null;
            }
            else{
                this.revertItem(this.editedItem)
            }
            //this.inProgress = false;
            this.removingProcess = false;
            this.showModal = false;
            this.modalType = null;
        },
        revertItem(item){
            _.each(item.cols, col=>{
                col['editedValue'] = _.get(col, 'value');
            });
            if(this.activeTab == 'sourceType'){
                item.units['editedValue'] = item.units['value'];
            }
            if(this.activeTab == 'scopeGroup'){
                item.sourceTypeGroups['editedValue'] = item.sourceTypeGroups['value'];
                item['selectedSourceTypeGroup'] = _.get(_.get(item, 'sourceTypeGroups'), 'editedValue') == undefined ? null : _.head(_.get(_.get(item, 'sourceTypeGroups'), 'editedValue'));
                
                
                item.sourceTypes['editedValue'] = item.sourceTypes['value'];
                /*
                let sourceGroupRel =  _.filter(item.rawData.relations, o=> _.get(o, 'rel_type') == 'source-group')
                _.each(_.groupBy(sourceGroupRel, 'tag_2'), (rel,relId)=>{
                    item.sourceTypes.editedValue[relId] = item.sourceTypes.value[relId];
                });
                */

                item.scope['editedValue'] = item.scope['value'];
                item.top['editedValue'] = item.top['value'];
                item.hazardous['editedValue'] = item.hazardous['value'];
            }
        },
        prepareData(){
            _.each(this.tabs.sourceType.data, data=>{
                data['units'] = {}
                data.units['value'] = _.map(data.rawData.units, 'id');
                data.units['editedValue'] = data.units['value'];

                let selectedTypes = [];
                _.each(data.units.value, o=>{
                    if(!_.includes(selectedTypes, this.unitTypeMap.id[o]) && this.unitTypeMap.id[o] != 'other'){
                        selectedTypes.push(this.unitTypeMap.id[o])
                    }
                })
                _.each(selectedTypes, selectedType=>{
                    if(!_.includes(Object.keys(data.cols['source_factors'].value), selectedType)){
                        data.cols['source_factors'].value[selectedType] = {}
                    }
                    _.each(this.unitTypes, unitType=>{
                        if(!(unitType==selectedType || unitType=='other') && !_.includes(Object.keys(data.cols['source_factors'].value[selectedType]), unitType)){
                            data.cols['source_factors'].value[selectedType][unitType] = {
                                from:null,
                                to:null,
                                value:null
                            }
                        }
                    });
                });
            });


            _.each(this.tabs, tab=>{
                _.each(tab.data, data=>{
                    _.each(data.cols, col=>{
                        col['editedValue'] = _.get(col, 'value');
                    });
                });
            });
            
            _.each(this.tabs.scopeGroup.data, data=>{
                let sourceGroupRel =  _.filter(data.rawData.relations, o=> _.get(o, 'rel_type') == 'source-group')

                data['sourceTypeGroups'] = {};
                data.sourceTypeGroups['value'] = _.uniq(_.map(sourceGroupRel, 'tag_2'));
                data.sourceTypeGroups['editedValue'] = data.sourceTypeGroups['value'];

                data['selectedSourceTypeGroup'] = _.get(_.get(data, 'sourceTypeGroups'), 'editedValue') == undefined ? null : _.head(_.get(_.get(data, 'sourceTypeGroups'), 'editedValue'));
                
                data['sourceTypes'] = {value:{},editedValue:{}};
                _.each(_.groupBy(sourceGroupRel, 'tag_2'), (rel,relId)=>{
                    data.sourceTypes.value[relId] = _.map(rel, 'rel_id');
                    data.sourceTypes.editedValue[relId] = _.clone(data.sourceTypes.value[relId]);
                });

                data['scope'] = {};
                data.scope['value'] = _.get(_.get(data, 'rawData'), 'scope');
                data.scope['editedValue'] = data.scope['value'];

                data['top'] = {};
                data.top['value'] = _.get(_.get(data, 'rawData'), 'top');
                data.top['editedValue'] = data.top['value'];

                data['hazardous'] = {};
                data.hazardous['value'] = _.get(_.get(data, 'rawData'), 'hazardous') != undefined;
                data.hazardous['editedValue'] = data.hazardous['value'];
            });
            
        },
        init(){
            this.isLoaded = true;
            this.$Progress.start();
            return this.axios.get('/getTagManagement').then(({data}) => {
                // TODO: extract cols and remove editedValue from data 
                this.tabs.units.data = _.get(data, 'units');
                this.tabs.sourceType.data = _.get(data, 'sourceType');
                this.tabs.sourceTypeGroup.data = _.get(data, 'sourceTypeGroup');//sou
                this.tabs.scopeGroup.data = _.get(data, 'scopeGroup');
                this.scopes = _.get(data, 'scopes');
                this.tops = _.get(data, 'tops');
                this.hazardous = _.get(data, 'hazardous');

                this.unitMap = {};
                this.sourceTypeMap = {};
                this.sourceTypeGroupMap = {};

                this.unitList = _.map(_.get(data, 'units'), nData=>{
                    this.unitMap[nData.id] = _.get(_.get(_.get(nData, 'cols'), 'name'), 'value');
                    this.unitTypeMap.name[this.unitMap[nData.id]] = _.get(_.get(_.get(nData, 'cols'), 'type'), 'value');
                    this.unitTypeMap.id[nData.id] = this.unitTypeMap.name[this.unitMap[nData.id]]
                    // nData.cols.type.value != null 
                    //     ? this.unitFilter[nData.cols.type.value].push({id:nData.cols.id.value, name:nData.cols.name.value})
                    //     : '';
                    if(this.unitFilter[nData.cols.type.value]) {
                        this.unitFilter[nData.cols.type.value].push({id:nData.cols.id.value, name:nData.cols.name.value});
                    }
                    return {
                        id: nData.id,
                        label: this.unitMap[nData.id] 
                    }
                });
                this.sourceTypeList = _.map(_.get(data, 'sourceType'), nData=>{
                    this.sourceTypeMap[nData.id] = _.get(_.get(_.get(nData, 'cols'), 'name'), 'value');
                    return {
                        id: nData.id,
                        label: this.sourceTypeMap[nData.id]
                    }
                });
                this.sourceTypeGroupList = _.map(_.get(data, 'sourceTypeGroup'), nData=>{
                    this.sourceTypeGroupMap[nData.id] = _.get(_.get(_.get(nData, 'cols'), 'name'), 'value');
                    return {
                        id: nData.id,
                        label: this.sourceTypeGroupMap[nData.id]
                    }
                });
                
            }).then(()=>{
                this.prepareData();
                this.isLoaded = false;
                this.inProgress = false;
                return this.$Progress.finish();
            });
        }  
    },
    created(){
        this.init();
    }
        
};
</script>

<style lang="scss" scoped>
#tabs .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    border: none;
    background-color: transparent;
    border-color: transparent transparent #f3f3f3;
    font-size: 16px;
    font-weight: bold;
}
.nav-tabs{
    color: #A7A7A7;
}
.nav-tabs:hover, .nav-link:hover {
    border: none;
}
.circle-icon {
    background: #777879;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    height: auto;
    width: auto;
    padding: 10px;
}

/deep/ .el-transfer-panel {
  width: 37% !important;
}

.edit-column {
    position: static;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-left: none;
}
.tableBodyCell {
    height: 30px;
}
/deep/ .page-item.active .page-link {
    background-color: #41B884;
    border-color: #41B884;
}
/deep/ .page-link {
    color: #41B884;
    border-color: #41B884;
}
/deep/ .page-item.disabled .page-link {
    color: #41B884;
    border-color: #41B884;
}
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "tagManagement": "Etiket Yönetimi",
            "couldBeHazardous": "Bu kapsam grubuna sahip veri türleri tehlikeli olarak ayarlanabilir",
            "code": "Kod",
            "displayName": "Görünen Ad",
            "description": "Açıklama",
            "units": "Birimler",
            "scope": "Scope",
            "top": "Top",
            "sourceType": "Kaynak Tipi",
            "sourceTypes": "Kaynak Tipleri",
            "sourceTypeGroup": "Kaynak Tipi Grubu",
            "sourceTypeGroups": "Kaynak Tipi Grubu (Kullanım amacı)",
            "scopeGroup": "Scope Grubu",
            "allUnits": "Bütün Birimler",
            "selectedUnits": "Seçili Birimler",
            "searchUnit": "Birim Ara",
            "allSourceTypes": "Bütün Kaynak Tipleri",
            "selectedSourceTypes": "Seçili Kaynak Tipleri",
            "searchSourceType": "Kaynak Tipi Ara",
            "allSourceTypeGroups": "Bütün Kaynak Tipi Grupları",
            "selectedSourceTypeGroups": "Seçili Kaynak Tipi Grupları",
            "searchSourceTypeGroup": "Kaynak Tipi Grubu Ara",
            "hazardous": "Tehlikeli",
            "addUnitBtn": "Birim Ekle",
            "addSourceTypeBtn": "Kaynak Tipi Ekle",
            "addSourceTypeGroupBtn": "Kaynak Tipi Grubu Ekle",
            "addScopeBtn": "Scope Ekle",
            "deletion-warn": "Seçili hedefi kalıcı olarak silmek istediğinizden emin misiniz?",
            "longProcessNotification": "Bu işlem biraz zaman alabilir, lütfen bekleyin. İşlem tamamlandığında tablo otomatik olarak yenilenecektir.",
            "targetInUse": "Seçili hedef bir veya daha fazla yerde kullanılmakta olduğu için silinemedi.",
            "mass": "Ağırlık",
            "volume": "Hacim",
            "energy": "Enerji",
            "othet": "Diğer",
            "type": "Tür",
            "base": "Kaynak",
            "target": "Hedef",
            "anchor": "Çarpan",
            "exapmle": "Örnek",
            "sourceTypeGroupHeader": "Kaynak Tipi Grubu Başlığı",
            "scopeIcon": "Scope Grubu İkonu",
            "tagsLoading": "Etiket Listesi Yükleniyor..."
        },
        "en": {
            "tagManagement": "Tag Management",
            "couldBeHazardous": "Data types with this scope group can be set as hazardous",
            "code": "Code",
            "displayName": "Display Name",
            "description": "Description",
            "units": "Units",
            "scope": "Scope",
            "top": "Top",
            "sourceType": "Source Type",
            "sourceTypes": "Source Types",
            "sourceTypeGroup": "Source Type Group",
            "sourceTypeGroups": "Source Type Group (Usage For)",
            "scopeGroup": "Scope Group",
            "allUnits": "All Units",
            "selectedUnits": "Selected Units",
            "searchUnit": "Search Unit",
            "allSourceTypes": "All Source Types",
            "selectedSourceTypes": "Selected Source Types",
            "searchSourceType": "Search Source Type",
            "allSourceTypeGroups": "All Source Type Groups",
            "selectedSourceTypeGroups": "Selected Source Type Groups",
            "searchSourceTypeGroup": "Search Source Type Group",
            "hazardous": "Hazardous",
            "addUnitBtn": "Add Unit",
            "addSourceTypeBtn": "Add Source Type",
            "addSourceTypeGroupBtn": "Add Source Type Group",
            "addScopeBtn": "Add Scope",
            "deletion-warn": "Are you sure you want to permanently delete the selected target?",
            "longProcessNotification": "This process may take some time, please wait. When the process is complete, the table will be refreshed automatically.",
            "targetInUse": "The selected target could not be deleted because it is used in one or more places.",
            "mass": "Mass",
            "volume": "Volume",
            "energy": "Energy",
            "othet": "Other",
            "type": "Type",
            "base": "Base",
            "target": "Target",
            "anchor": "Anchor",
            "exapmle": "Example",
            "sourceTypeGroupHeader": "Source Type Group Header",
            "scopeIcon": "Scope Group Icon",
            "tagsLoading": "Loading Tag List..."
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/Tags.vue